import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import './StatusBadge.css';

const StatusBadge = forwardRef(({ label, color, outline, className, style, ...rest }, ref) => (
    <span
        ref={ref}
        className={`statusBadge ${className || ''}`}
        style={{
            backgroundColor: outline ? 'transparent' : color,
            borderColor: color,
            color: outline ? color : '#FFFFFF',
            textTransform: 'capitalize',
            textAlign: 'center',
            ...style,
        }}
        {...rest}
    >
        {label}
    </span>
));

StatusBadge.displayName = 'StatusBadge';

StatusBadge.propTypes = {
    label: PropTypes.node,
    color: PropTypes.string,
    outline: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
};

StatusBadge.defaultProps = {
    color: '#888888',
    outline: false,
};

export default StatusBadge;
